/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Definitions_Tenant_DescInputs */

const es_tyc_definitions_tenant_desc = /** @type {(inputs: Tyc_Definitions_Tenant_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La organizacion o entidad para la cual el Usuario esta autorizado a usar el Servicio.`)
};

const en_tyc_definitions_tenant_desc = /** @type {(inputs: Tyc_Definitions_Tenant_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The organization or entity for which the User is authorized to use the Service.`)
};

/**
* | output |
* | --- |
* | "The organization or entity for which the User is authorized to use the Service." |
*
* @param {Tyc_Definitions_Tenant_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_definitions_tenant_desc = /** @type {((inputs?: Tyc_Definitions_Tenant_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Definitions_Tenant_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_definitions_tenant_desc(inputs)
	return en_tyc_definitions_tenant_desc(inputs)
});
export { tyc_definitions_tenant_desc as "tyc.definitions.tenant_desc" }